/**
 * Lane SCENE-PLAINS, BUILDINGS-R1 §6: a stone podium under a hall. The building keeps its footprint (so its collision
 * is unchanged): the podium fills the footprint and the building's own base stands on top, `lift` px higher; the
 * stair is painted on the near-left face. Use instead of `stage()`.
 */
import { snap, wall, M } from '../buildings';
import { plinthK, type Stage } from './common';
import { stage } from './parts';

export function podiumStage(w: number, h: number, Z: number, pad: number, lift: number, stairW = 3.2): Stage {
  const base = stage(w, h, Z + lift, pad);
  const P0 = base.P;
  plinthK({ ...base, P: P0 }, [0, 0, w, h], lift, false);
  const c = w / 2;
  wall(base.px, P0, 'left', h + 0.02, c - stairW / 2, c + stairW / 2, 0, lift, (u, v, l) => {
    const tread = v % 3 < 1;
    return snap(M.stone, l + (tread ? 0.3 : -0.12) + ((u | 0) % 9 === 0 ? -0.15 : 0), u | 0, v | 0, 0.2);
  });
  return { ...base, P: (x, y, z) => P0(x, y, z + lift) };
}
